import React from "react";

export const mediaBlockRenderer = block => {

    // console.log(block.getType())
    
    if (block.getType() === 'header-two') {
        return {
            component: Header
        }
    }

    if (block.getType() === 'header-three') {
        return {
            component: Header
        }
    }

    if (block.getType() === "atomic") {
        return {
            component: Media,
            editable: false
        };
    }
    return null;
   };

const Header = props => {
    let text = props.block.text
    return <span id={text.split(' ').join('-')}>{text}</span>
}

const Image = props => {
    // console.log('Image Found')
    // console.log(props.src) //unstyled
    if (!!props.src) {
        // return <img src={props.src} style={{maxWidth:150, maxHeight:150}}/>;
    }
    
    return null;
};

const Media = props => {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    // console.log('getting entity')
    // console.log(entity)
    const { src } = entity.getData();
    const type = entity.getType();
    
    let media;
    if (type === "image") {
        media = <Image src={src} />;
    }
    return media;
};


// WEBPACK FOOTER //
// ./src/components/docs/entities/mediaBlockRenderer.js